import { render, staticRenderFns } from "./CatalogIcon.vue?vue&type=template&id=8ffc960c&scoped=true&"
import script from "./CatalogIcon.vue?vue&type=script&lang=ts&"
export * from "./CatalogIcon.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogIcon.vue?vue&type=style&index=0&id=8ffc960c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffc960c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
